import actionCreatorFactory from 'typescript-fsa';

import reduxConfig from '../config';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/router');

export const pushHistoryByUrl = actionCreator<string>('HISTORY_PUSH');
export const parsePathParameters = actionCreator<any>('PARSE_PATH_PARAMS');
